import {
    AtSign,
    BarChart3,
    BookOpen,
    Building2,
    FileText,
    Home,
    KeyRound,
    LayoutGrid,
    Mail,
    Send,
    Settings,
    Terminal,
    type LucideIcon,
    User,
    Users
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
    AtSign,
    BarChart3,
    BookOpen,
    Building2,
    FileText,
    Home,
    KeyRound,
    LayoutGrid,
    Mail,
    Send,
    Settings,
    Terminal,
    User,
    Users
};

export function getIcon(name: string): LucideIcon {
    return iconMap[name] ?? FileText;
}
